module.exports = __webpack_public_path__ + "fe14a6066b297f1848cbaafa1efb22c5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/trumbowyg/dist/ui/icons.svg
// module id = ./node_modules/trumbowyg/dist/ui/icons.svg
// module chunks = 0